import React, { useState } from "react";
import { toast } from "react-toastify";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../services/ApiService";
import logo from '../assets/images/logo.png'; 
import Loader from '../components/Loader'; 


const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: "POST",
        url: `forgotPassword`,
        data: formData,
      });
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        navigate('/reset-password?email='+formData.email);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      toast.error("ForgotPassword failed!");
      setIsLoader(false);
    }
  };

  return (
    <>
      <div className="page-body-wrapper full-page-wrapper bg-light">
        <div className="row w-100 m-0 full-page-wrapper">
          <div className="content-wrapper full-page-wrapper d-flex align-items-center auth">
            <div className="col-lg-4 mx-auto">
              <div className="text-center bg-base">
                <img alt="Logo" src={logo} className="w-175px mb-2" />
              </div>
              <div className="card">
                <div className="card-body px-5 py-5">
                  <div className="text-center my-3">
                    <h3 className="card-title mb-0 fs-2">Forgot Password</h3>
                    <p>Don't worry just enter your email and get recovery email to get reset it.</p>
                  </div>
                  <br />

                  <form onSubmit={handleSubmit}>
                    <div className="form-group my-5">
                      <label>Email Address *</label>
                      <input
                        name="email"
                        type="email"
                        required
                        autoComplete="off"
                        value={formData.email}
                        onChange={handleChange}
                        className="form-control p_input"
                        placeholder="Email Address"
                      />
                    </div>


                    <div className="row">
                     
                      <div className="col-md-12 text-end">
                        <Link to="/login" className="text-base">Already have account? Login.</Link>
                      </div>
                    </div>

                    <div className="text-center my-5">
                      <button
                        type="submit"
                        disabled={isLoader}
                        className="btn btn-base w-100 btn-block"
                      >
                        <span  hidden={isLoader}>
                          Forgot Password
                        </span>
                        {isLoader && <Loader size="20" text="Signing" color="black" />}
                      </button>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
  

    </>
  );
};

export default ForgotPassword;
